import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, AbstractControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CrudVendorService } from 'app/_services/MasterCrudOps/crud-vendor.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
declare const swal: any;


@Component({
  selector: 'app-add-vender',
  templateUrl: './add-vender.component.html',
  styleUrls: ['./add-vender.component.css']
})


export class AddVenderComponent implements OnInit {
  addVendorForm: UntypedFormGroup;
  pageNumber: number;
  pageSize: number;

  constructor(
    private readonly toastr: ToastrService,
    private readonly crudVendorService:CrudVendorService,
    private readonly dialogRef: MatDialogRef<AddVenderComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.pageNumber = data.pageNumber;
      this.pageSize = data.pageSize;
     }

  ngOnInit() {
    this.initilizeForm();
  }

  initilizeForm() {
     this.addVendorForm = this.formBuilder.group({
      vendorCode: [null, [Validators.required, Validators.maxLength(15)]],
      vendorName: [null, [Validators.required,  Validators.maxLength(50)]],
      description: [null, [Validators.required, Validators.maxLength(100)]],
      address: [null, [Validators.required, Validators.maxLength(250)]],
      emailIds:[null, [Validators.required, this.emailListValidator, Validators.maxLength(100)]],
      contactNumbers:[null, [Validators.required, this.contactNumberValidator, Validators.maxLength(100)]]
    })
  }
   

    // Validator for comma-separated email IDs
    emailListValidator(control: AbstractControl): { [key: string]: any } | null {
      const emailIds = control.value ?? '';
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      
      // Split by semicolons and trim whitespace
      const emails = emailIds.split(';').map((email: string) => email.trim());
  
      // Check if any email does not match the email pattern
      const invalidEmails = emails.filter(email => !emailPattern.test(email));
      return invalidEmails.length ? { invalidEmailIds: true } : null;
    }
  
    // Validator for semicolon-separated contact numbers (each should be 10 digits)
    contactNumberValidator(control: AbstractControl): { [key: string]: any } | null {
      const contactNumbers = control.value ?? '';
      const contactNumberPattern = /^\d{10}$/;
      const numbers = contactNumbers.split(';').map((number: string) => number.trim());
  
      const invalidNumbers = numbers.filter(number => !contactNumberPattern.test(number));
      return invalidNumbers.length ? { invalidContactNumbers: true } : null;
    }

  saveVendor() {

    let errorMessage = '';
    const vendorCode = (this.addVendorForm.value.vendorCode ?? '').trim();
    const vendorName = (this.addVendorForm.value.vendorName ?? '').trim();
    const description = (this.addVendorForm.value.description ?? '').trim();
    const address = (this.addVendorForm.value.address ?? '').trim();
     const emailIds =  (this.addVendorForm.value.emailIds ?? '').trim();
    const contactNumbers = (this.addVendorForm.value.contactNumbers ?? '').trim();

    if (vendorCode.length > 15) {
      errorMessage = "Vendor code cannot be more than 15 characters.";
    }
    if (vendorName.length > 50) {
      errorMessage = "Vendor Name cannot be more than 50 characters.";
    }
    if (address.length > 250) {
      errorMessage = "Address cannot be more than 250 characters.";
    }
    if (emailIds.length > 100) {
      errorMessage = "EmailIds cannot be more than 100 characters.";
    }
    if (contactNumbers.length > 100) {
      errorMessage = "contact numbers cannot be more than 100 characters.";
    }
    if (description.length > 100) {
      errorMessage += "\nDescription cannot be more than 100 characters.";
    }

    if (errorMessage) {
      swal({
        title: "",
        text: errorMessage,
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
      return;
    }

    swal({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'YES, Add IT!'
    }).then((result) => {
      if (result === true) {
        let model = {vendorCode: vendorCode, vendorName:vendorName, description: description,
          address: address, emailIds: emailIds, contactNumbers: contactNumbers };
        this.addVendor(model);
      }
      else {
        this.toastr.info('result not saved')
      }
    })
  }


  addVendor(model:any) {
    this.crudVendorService.addVendor(model)
    .subscribe(
      data =>
      {
        if (data.didError) {
          swal({
            title: data.message,
            text: data.additionalMessage,
            type: 'error',
            confirmButtonClass: 'btn btn-info'
          });
        }
        else {
          swal({
            title: '',
            text: data.message,
            type: 'success',
            confirmButtonClass: 'btn btn-info'
          });
          let result = {
            status: true,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize
          };
          this.dialogRef.close(result);
        }
      },
      (error) => {
         let errorMessage =
          error.error?.title ??
          error.error ??
          "Something went wrong. Please contact admin.";

        // Check if it's a validation error response with the `errors` object
        if (error.error?.errors) {
          const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
          if (allErrors.length > 0) {
            errorMessage = allErrors[0]; // Use the first validation message
          }
        } else if (typeof error.error === "string") {
          errorMessage = error.error;
        } else if (error.error?.title) {
          errorMessage = error.error.title;
        }

        swal({
          title: '',
          text: errorMessage,
          type: 'error',
          confirmButtonClass: 'btn btn-info'
        });
      }
     )
  }


  close() {
    this.dialogRef.close(false);
  }
}


 
